/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlSupplementalFormInstanceWithAttachment } from './ControlSupplementalFormInstanceWithAttachment';
import {
    ControlSupplementalFormInstanceWithAttachmentFromJSON,
    ControlSupplementalFormInstanceWithAttachmentFromJSONTyped,
    ControlSupplementalFormInstanceWithAttachmentToJSON,
} from './ControlSupplementalFormInstanceWithAttachment';

/**
 * 
 * @export
 * @interface ControlSupplementalCreateFormInstanceResponse
 */
export interface ControlSupplementalCreateFormInstanceResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlSupplementalCreateFormInstanceResponse
     */
    recipient_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSupplementalCreateFormInstanceResponse
     */
    account_uuid: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSupplementalCreateFormInstanceResponse
     */
    quote_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSupplementalCreateFormInstanceResponse
     */
    policyholder_email?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSupplementalCreateFormInstanceResponse
     */
    jira_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSupplementalCreateFormInstanceResponse
     */
    broker_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSupplementalCreateFormInstanceResponse
     */
    broker_email?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSupplementalCreateFormInstanceResponse
     */
    locale: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSupplementalCreateFormInstanceResponse
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof ControlSupplementalCreateFormInstanceResponse
     */
    updated_at: string;
    /**
     * 
     * @type {ControlSupplementalFormInstanceWithAttachment}
     * @memberof ControlSupplementalCreateFormInstanceResponse
     */
    form_instance: ControlSupplementalFormInstanceWithAttachment;
}

/**
 * Check if a given object implements the ControlSupplementalCreateFormInstanceResponse interface.
 */
export function instanceOfControlSupplementalCreateFormInstanceResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recipient_id" in value;
    isInstance = isInstance && "account_uuid" in value;
    isInstance = isInstance && "locale" in value;
    isInstance = isInstance && "created_at" in value;
    isInstance = isInstance && "updated_at" in value;
    isInstance = isInstance && "form_instance" in value;

    return isInstance;
}

export function ControlSupplementalCreateFormInstanceResponseFromJSON(json: any): ControlSupplementalCreateFormInstanceResponse {
    return ControlSupplementalCreateFormInstanceResponseFromJSONTyped(json, false);
}

export function ControlSupplementalCreateFormInstanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSupplementalCreateFormInstanceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recipient_id': json['recipient_id'],
        'account_uuid': json['account_uuid'],
        'quote_uuid': !exists(json, 'quote_uuid') ? undefined : json['quote_uuid'],
        'policyholder_email': !exists(json, 'policyholder_email') ? undefined : json['policyholder_email'],
        'jira_id': !exists(json, 'jira_id') ? undefined : json['jira_id'],
        'broker_uuid': !exists(json, 'broker_uuid') ? undefined : json['broker_uuid'],
        'broker_email': !exists(json, 'broker_email') ? undefined : json['broker_email'],
        'locale': json['locale'],
        'created_at': json['created_at'],
        'updated_at': json['updated_at'],
        'form_instance': ControlSupplementalFormInstanceWithAttachmentFromJSON(json['form_instance']),
    };
}

export function ControlSupplementalCreateFormInstanceResponseToJSON(value?: ControlSupplementalCreateFormInstanceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recipient_id': value.recipient_id,
        'account_uuid': value.account_uuid,
        'quote_uuid': value.quote_uuid,
        'policyholder_email': value.policyholder_email,
        'jira_id': value.jira_id,
        'broker_uuid': value.broker_uuid,
        'broker_email': value.broker_email,
        'locale': value.locale,
        'created_at': value.created_at,
        'updated_at': value.updated_at,
        'form_instance': ControlSupplementalFormInstanceWithAttachmentToJSON(value.form_instance),
    };
}

